import { render } from "./custom.vue?vue&type=template&id=1a10521e&scoped=true"
import script from "./custom.vue?vue&type=script&lang=js"
export * from "./custom.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-1a10521e"

export default script